import { trackMediaQuery } from '@withease/web-api';
import { createEvent } from 'effector';
import { useUnit } from 'effector-react';
import { Breakpoint, BREAKPOINTS } from 'shared/config';

const setup = createEvent();

const xs = trackMediaQuery(`(width > ${BREAKPOINTS.xs}px)`, { setup });

const sm = trackMediaQuery(`(width > ${BREAKPOINTS.sm}px)`, { setup });

const md = trackMediaQuery(`(width > ${BREAKPOINTS.md}px)`, { setup });

const lg = trackMediaQuery(`(width > ${BREAKPOINTS.lg}px)`, { setup });

const xl = trackMediaQuery(`(width > ${BREAKPOINTS.xl}px)`, { setup });

export const breakpoints = {
	setup,
	xs: xs.$matches,
	sm: sm.$matches,
	md: md.$matches,
	lg: lg.$matches,
	xl: xl.$matches,
};

export const useBreakpoint = (breakpoint: Breakpoint) => useUnit(breakpoints[breakpoint]);
